import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { SectionLabel } from "./Section";
import { SKILLS, MARQUEE_SKILLS } from "../data/content";

export const Skills = ({ t }) => {
  return (
    <section id="skills" className="relative py-28 md:py-40 overflow-hidden">
      {/* Background outline marquee */}
      <div className="absolute inset-0 flex flex-col justify-center gap-6 -z-0 opacity-60 pointer-events-none select-none">
        <Marquee speed={40} gradient={false}>
          {MARQUEE_SKILLS.map((s, i) => (
            <span key={i} className="font-display font-extrabold text-7xl md:text-8xl text-stroke mx-8">
              {s}
            </span>
          ))}
        </Marquee>
        <Marquee speed={40} direction="right" gradient={false}>
          {MARQUEE_SKILLS.slice().reverse().map((s, i) => (
            <span key={i} className="font-display font-extrabold text-7xl md:text-8xl text-stroke mx-8">
              {s}
            </span>
          ))}
        </Marquee>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <SectionLabel num={t.skills.num} label={t.skills.label} id="skills" />

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-display font-bold tracking-tight text-3xl md:text-5xl"
          >
            {t.skills.title}
          </motion.h2>
          <p className="text-[#8b95a5] max-w-sm md:text-right">{t.skills.sub}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-3 md:gap-4 auto-rows-[110px] md:auto-rows-[130px]">
          {SKILLS.map((skill, i) => (
            <motion.div
              key={skill.name}
              initial={{ opacity: 0, scale: 0.94 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 6) * 0.05, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative bg-[#0c0e14]/90 backdrop-blur-sm border border-[#1a1d27] rounded-xl p-5 flex flex-col justify-between overflow-hidden hover:border-[#2563eb] transition-colors duration-300 ${skill.span}`}
            >
              <div className="absolute -right-8 -top-8 w-24 h-24 rounded-full bg-[#2563eb]/0 group-hover:bg-[#2563eb]/15 blur-2xl transition-colors duration-500" />
              <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#8b95a5]">{skill.tag}</span>
              <span className="font-display font-bold text-xl md:text-2xl text-white group-hover:text-[#2563eb] transition-colors duration-300">
                {skill.name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
